module.exports = __webpack_public_path__ + "img/knu2_gallery18.e6e8dc8f.jpg";